/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateEvalSuiteRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createEvalSuiteRequest: components.CreateEvalSuiteRequest;
};

/** @internal */
export const CreateEvalSuiteRequest$inboundSchema: z.ZodType<
  CreateEvalSuiteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreateEvalSuiteRequest: components.CreateEvalSuiteRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateEvalSuiteRequest": "createEvalSuiteRequest",
  });
});
/** @internal */
export type CreateEvalSuiteRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreateEvalSuiteRequest: components.CreateEvalSuiteRequest$Outbound;
};

/** @internal */
export const CreateEvalSuiteRequest$outboundSchema: z.ZodType<
  CreateEvalSuiteRequest$Outbound,
  z.ZodTypeDef,
  CreateEvalSuiteRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createEvalSuiteRequest: components.CreateEvalSuiteRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createEvalSuiteRequest: "CreateEvalSuiteRequest",
  });
});

export function createEvalSuiteRequestToJSON(
  createEvalSuiteRequest: CreateEvalSuiteRequest,
): string {
  return JSON.stringify(
    CreateEvalSuiteRequest$outboundSchema.parse(createEvalSuiteRequest),
  );
}
export function createEvalSuiteRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateEvalSuiteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateEvalSuiteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateEvalSuiteRequest' from JSON`,
  );
}
